<br>
<form id="employeeForm" #employeeForm="ngForm">
  <div class="p-grid">
    <div class="p-col-6">
      <h4>Employee Information</h4>

      <div class="row-container">
        <div style="flex-grow: 6;">
          <h6>First Name</h6>
          @if (employee) {
          <input pInputText name="firstName" [(ngModel)]="employee.firstName" [disabled]="!canEdit" required fluid />
          }
        </div>
        <div style="flex-grow: 6;">
          <h6>Last Name</h6>
          @if (employee) {
          <input pInputText name="lastName" [(ngModel)]="employee.lastName" [disabled]="!canEdit" required fluid />
          }
        </div>
      </div>
      <div>
        <div style="flex-grow: 12">
          <h6>Role(s)</h6>
          @if (employee) {
          <p-multiselect autofocusFilter placeholder="Choose" [options]="employeeRoleOptions" name="employeeRoles" [(ngModel)]="employee.employeeRoles"
            (ngModelChange)="updateEmployeIsRM()" [panelStyle]="{minWidth:'12em'}" optionLabel="role.name"
            [disabled]="!canEdit" required fluid>
            <ng-template let-value pTemplate="selectedItems">
              @for (val of value; track val) {
              <div class="ui-multiselected-item-token ui-corner-all">
                <span>{{val.role.name}}</span>
              </div>
              }
              @if (!value || value.length === 0) {
              <span class="ui-multiselected-empty-token ui-corner-all">Choose</span>
              }
            </ng-template>
            <ng-template let-er pTemplate="item">
              {{er.role.name}}
            </ng-template>
          </p-multiselect>
          }
        </div>
      </div>
      <div class="row-container">
        <div style="flex-grow: 6;">
          <h6>Phone Number</h6>
          @if (employee) {
          <input pInputText placeholder="(     )      -" name="phoneNumber" [(ngModel)]="employee.phoneNumber"
            [disabled]="!canEdit" fluid />
          }
        </div>
        <div style="flex-grow: 6;">
          <h6>Email</h6>
          @if (employee) {
          <input pInputText name="emailAddress" [(ngModel)]="employee.emailAddress.email" required [disabled]="!canEdit"
            email fluid />
          }
        </div>
      </div>
      <div class="row-container">
        <div style="flex-grow: 12">
          <h6>Address</h6>
          @if (employee) {
          <input pInputText name="street" [(ngModel)]="employee.address.street" [disabled]="!canEdit" required fluid />
          }
        </div>
      </div>
      <div class="row-container">
        <div style="flex-grow: 4">
          <h6>City</h6>
          @if (employee) {
          <input pInputText name="city" [(ngModel)]="employee.address.city" [disabled]="!canEdit" required fluid />
          }
        </div>
        <div style="flex-grow: 4">
          <h6>State</h6>
          @if (employee) {
          <ng-select class="custom" required [items]="states" placeholder="Select a State"
            (ngModelChange)="onStateSelect($event)" name="state" [selectOnTab]="true" bindLabel="name"
            [(ngModel)]="selectedState" [disabled]="!canEdit">
          </ng-select>
          }
        </div>
        <div style="flex-grow: 4">
          <h6>Zip</h6>
          @if (employee) {
          <input pInputText name="zip" [(ngModel)]="employee.address.zip" [disabled]="!canEdit" required fluid />
          }
        </div>
      </div>
      <div class="row-container">
        <div style="flex-grow: 12">
          <h6>Signature</h6>
          @if (employee) {
          <textarea pInputTextarea class="form-control" rows="5" name="signature" style="width: 100%;"
            [(ngModel)]="employee.employeeSignature" placeholder="Add Your Signature Here"
            [disabled]="!canEdit && !employeeIsRM" fluid></textarea>
          }
        </div>
      </div>
      @if (employee) {
      <div class="row-container">
        <div style="flex-grow: 4">
          <h6>Currently Employed</h6>
          <p-checkbox binary="true" name="currentlyEmployed" [(ngModel)]="employee.currentlyEmployed"
            [disabled]="!canEdit"></p-checkbox>
        </div>
        @if (employeeIsRM) {
        <div style="flex-grow: 4">
          <h6>Sales Goal</h6>
          <p-inputgroup>
            <p-inputgroup-addon>$</p-inputgroup-addon>
            <p-inputnumber name="salesGoal" [(ngModel)]="employee.salesGoal" [disabled]="!canEdit" (ngModelChange)="currencyInputChanged($event)" />
          </p-inputgroup>
        </div>
        }
        @if (employeeIsRM) {
        <div style="flex-grow: 4" style="text-align: right;">
          <h6>&nbsp;<!-- Spacer so button is aligned with textboxes --></h6>
          <p-button label="Go To Employee's RM Schedule" (click)="navigateToRMSchedulingPage()" severity="info"></p-button>
        </div>
        }
      </div>
      }
    </div>
    <div class="p-col-6">
      <h4>
        Skills/Certifications
        <span style="float: right;">
          <p-button type="button" (click)="addNewSkill();" [disabled]="!canEdit">Add Skill</p-button>
        </span>
      </h4>
      <br />
      <div>
        @if (employee) {
        <p-table showGridlines stripedRows responsiveLayout="stack" [columns]="cols" [value]="employee.employeeSkills">
          <ng-template pTemplate="header" let-columns>
            <tr>
              @for (col of columns; track col) {
              <th [style.width]="col.width" [pSortableColumn]="col.field">
                {{col.header}}
                @if (col.filterable) {
                <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                  ariaLabelDesc="Activate to sort in descending order"
                  ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                }
              </th>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-employeeSkill let-columns="columns" let-rowIndex="rowIndex">
            <tr>
              <td pEditableColumn><span class="p-column-title">{{columns[0].header}}</span>
                <ng-select appendTo="body" class="custom" required [items]="skills" placeholder="Select a Skill"
                  [selectOnTab]="true" (ngModelChange)="onSkillChange(employeeSkill, $event)" [name]="'skill'+rowIndex"
                  bindLabel="shortName" [disabled]="!canEdit" [(ngModel)]="employeeSkill.skill">
                </ng-select>
              </td>
              <td pEditableColumn><span class="p-column-title">{{columns[1].header}}</span>
                <p-datepicker [(ngModel)]="employeeSkill.fromDate" [name]="'fromDate'+rowIndex"
                  (ngModelChange)="onSkillFromDateChange(employeeForm, rowIndex, employeeSkill)" [appendTo]="'body'"
                  class="dateInTable" dateFormat="mm/dd/yy" placeholder="MM/DD/YYYY" [disabled]="!canEdit" required>
                </p-datepicker>
              </td>
              <td pEditableColumn><span class="p-column-title">{{columns[2].header}}</span>
                <p-datepicker [(ngModel)]="employeeSkill.toDate" [minDate]="employeeSkill.fromDate"
                  [appDateGreaterThanValidator]="employeeSkill.fromDate" [name]="'toDate'+rowIndex" [appendTo]="'body'"
                  class="dateInTable" dateFormat="mm/dd/yy" placeholder="MM/DD/YYYY" [disabled]="!canEdit" required>
                </p-datepicker>
              </td>
              <td style="word-wrap: break-word;"><span class="p-column-title">{{columns[3].header}}</span>
                <app-employee-skill-upload [employeeSkill]="employeeSkill"
                  [viewOnly]="!canEdit"></app-employee-skill-upload>
              </td>
              <td><span class="p-column-title">{{columns[4].header}}</span>
                <p-button type="button" severity="danger" [disabled]="!canEdit" (click)="removeSkill(rowIndex);">
                  <i class="pi pi-trash"></i>
                </p-button>
              </td>
            </tr>
          </ng-template>
        </p-table>
        }
      </div>
      @if (canAssignReports) {
      <div>
        <h4>Report Tiles</h4>
      </div>
      }
      @if (canAssignReports) {
      <div>
        @for (reportTile of allReportTiles; track reportTile) {
        <div>
          <p-checkbox [(ngModel)]="selectedReports" name="group" [value]="reportTile.id"
            [inputId]="'report-' + reportTile.id"></p-checkbox>
          <label [for]="'report-' + reportTile.id">{{reportTile.companyWide ? 'CW ' + reportTile.name :
            reportTile.name}}</label>
        </div>
        }
        <p-button type="button" severity="primary" label="Reset to Role Defaults"
          [disabled]="saving || (!canEdit && !employeeIsRM)" (click)="resetReportsToDefault()">
        </p-button>
      </div>
      }
    </div>
  </div>
  @if (employee) {
  <div class="row-container" style="flex-direction: row-reverse; justify-content: space-between;">
    <div>
      <p-button type="button" severity="danger" label="Delete" [disabled]="disableDelete" (click)="delete()">
      </p-button>
      <p-button type="button" severity="warn" label="Cancel" (click)="cancel()">
      </p-button>
      <p-button type="submit" severity="success" label="Save" [disabled]="saving || (!canEdit && !employeeIsRM)"
        (click)="save(employeeForm)">
      </p-button>
    </div>
    @if (employeeForm.invalid && employeeForm.submitted) {
    <div class="alert alert-danger" role="alert">
      There are errors on this page. Please correct the errors and resubmit.
    </div>
    }
  </div>
  }
</form>